var myHeaders = new Headers();
myHeaders.append("fetch", "completions-content");
myHeaders.append("Content-Type", "application/json");

var myHeaders2 = new Headers();
myHeaders2.append("fetch", "completions-titles");
myHeaders2.append("Content-Type", "application/json");


const itemsPerPage = 3;
var items = [];
var bookdata = [];
var itemsarray = [];

async function goForSearch(ele) {
    // console.log("evenrwerewrewrt", ele.target.value)

  if (event.key === "Enter") {
    await searchfunc();
  } else if (ele == "arrowclick") {
    await searchfunc();
  } else if (ele == "refreshcontent") {
    await searchfunc();
  }
}

function handleKeyDown(event) {
  console.log("event", event.target.value)
  if (event.key === "Enter") {
    searchfunc();

    const tryAgainButton = document.getElementById("tryAgainButton");
    if (tryAgainButton) {
      // tryAgainButton.style.display = "none"; // Hide the button
    }
    document.getElementById("resultDescription").style.display = "flex";
    document.getElementById("seeLessMoreBtnTxt").style.display = "flex";
    document.getElementById("seeLessMoreBtn").style.display = "flex";
  }
}

let text1CallCount = 0;
function validateSearchInput() {
  const input = document.getElementById("searchResultText") || document.getElementById("searchFrmText") ;
  const errorElement = document.getElementById("errorSearchResultText");

  // Clear any existing error message
  errorElement.textContent = "";
  errorElement.style.display = "none";

  // Check if the input field is empty or contains only whitespace
  if (input.value.trim() === "") {
    errorElement.textContent = "Please enter some text for search.";
    errorElement.style.display = "block";

    // Hide the error message after 5 seconds
    setTimeout(() => {
      errorElement.style.display = "none";
    }, 5000);

    return false; // Prevent further operations
  }

  return true; // Input is valid, proceed with the operation
}
// function validateSearchFrmInput() {
//   const input = document.getElementById("searchFrmText");
//   const errorElement = document.getElementById("errorSearchFrmText");

//   // Clear any existing error message
//   errorElement.textContent = "";
//   errorElement.style.display = "none";

//   // Check if the input field is empty or contains only whitespace
//   if (input.value.trim() === "") {
//     errorElement.textContent = "Please enter some text for search.";
//     errorElement.style.display = "block";

//     // Hide the error message after 5 seconds
//     setTimeout(() => {
//       errorElement.style.display = "none";
//     }, 5000);

//     return false; // Prevent further operations
//   }

//   return true; // Input is valid, proceed with the operation
// }


async function searchfunc() {
  //  if (!validateSearchInput()) {
  //   return; // Stop execution if validation fails
  // }
  let text = document.getElementById("searchFrmText").value;
  let text1 = document.getElementById("searchResultText").value || "what ?";
  console.log("texttttttt", text, text1)
  // If text exists and meets the condition, call the API
  if (text !== "" && text.length > 1) {
    console.log("kkkllkkl;;lk;k;k")
    
    await fetchBookData(text);
    // Clear the input field only if needed
    document.getElementById("searchFrmText").value = "";
    window.scrollTo({ top: 0, behavior: "smooth" });
    return; // Stop further execution to avoid checking text
  }

  // If text1 exists and meets the condition, call the API
  if (text1 !== "" && text1.length > 1) {
    bookName = "search"; 
    console.log("anananananan", text1)
    await fetchBookData(text1);
    // Clear the input field only if needed
    document.getElementById("searchResultText").value = "";
    window.scrollTo({ top: 0, behavior: "smooth" });
    const seeLessMoreBtnTxt = document.getElementById("seeLessMoreBtnTxt");
    setTimeout(() => {
      seeLessMoreBtnTxt.textContent = "See More";
    }, 3000);
    document.getElementById("searchResultText").value = "";
    return;
  }
}

// async function searchfunc() {
//   let text = document.getElementById("searchFrmText").value || document.getElementById("searchFrmText").value;
//   let text1 = document.getElementById("searchResultText").value || "what ?";

//   // If text exists and meets the condition, call the API
//   if (text !== "" && text.length > 1) {
//     await fetchBookData(text);
//     // Clear the input field only if needed
//     document.getElementById("searchFrmText").value = "";
//     return; // Stop further execution to avoid checking text1
//   }

//   // If text1 exists and meets the condition, call the API
//   if (text1 !== "" && text1.length > 1) {
//     await fetchBookData(text1);
//     // Clear the input field only if needed
//     document.getElementById("searchResultText").value = "";
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }
// }

function getBookNameFromUrl(url) {
  const match = url.match(/bookName=([^]*)/);
  if (match) {
    return decodeURIComponent(match[1]); // Decode and return the value
  }
  return null; // Return null if bookName is not found
}

// Example usage
const url = window.location.href;
console.log("Full URL:", url);
let bookName = getBookNameFromUrl(url);


var bookdata = []
  async function fetchBookData(searchText) {
    console.log("searchText", searchText);

    // Default searchText if empty
    searchText = searchText && searchText.trim() !== "" ? searchText : "What is machine learning?";

    const raw1 = JSON.stringify({
        messages: [{ role: "user", content: searchText }],
        temperature: 0.7,
        top_p: 0.95,
        frequency_penalty: 0,
        presence_penalty: 0,
        max_tokens: 800,
        stop: null,
        stream: false,
    });

    const requestOptions1 = {
        method: "POST",
        headers: myHeaders,
        body: raw1,
        redirect: "follow",
    };

    const raw2 = JSON.stringify({
        bookName: bookName ? bookName : "default",
        messages: [{ role: "user", content: searchText }],
        temperature: 0.7,
        top_p: 0.95,
        frequency_penalty: 0,
        presence_penalty: 0,
        max_tokens: 800,
        stop: null,
        stream: false,
    });

    const requestOptions2 = {
        method: "POST",
        headers: myHeaders2,
        body: raw2,
        redirect: "follow",
    };

    try {
        // First API call
        const response1 = await fetch("https://newintellectual.com/a/customService", requestOptions1);
        const statusCode = response1.status;
        const resultFirst = await response1.json();
        console.log("resultFirst", resultFirst);

        displayApiContent(searchText, resultFirst, statusCode);

        const resultAPIdata = resultFirst.choices[0]?.message?.newContent || "";
        const bookQuestions = resultFirst.choices[0]?.questions || [];

        // Update follow-up questions
        const ul = document.getElementById("followup-question");
        const seeLessMoreBtnTxt = document.getElementById("seeLessMoreBtnTxt");
        ul.innerHTML = "";

        if (resultAPIdata && bookQuestions.length > 0) {
            bookQuestions.forEach((question) => {
                const li = document.createElement("li");
                li.textContent = question;
                ul.appendChild(li);

                li.addEventListener("click", () => {
                    bookName = getBookNameFromUrl(url);
                  // console.log("here!!!!!!!!!!!!!!!");
                    // console.log("Li clicked", getBookNameFromUrl(url));
                    document.getElementById("searchFrmText").value = li.textContent;
                    document.getElementById("searchbtn").click();
                    window.scrollTo(0, 0);
                    setTimeout(() => {
                        seeLessMoreBtnTxt.textContent = "See More";
                    }, 3000);
                });
            });
        }

        // Second API call
        const response2 = await fetch("https://newintellectual.com/a/customService", requestOptions2);
        const datares = await response2.json();

        if (!response2.ok) throw new Error("Response was not OK");

        // Process the result from the second API
        const filePath = datares.choices[0]?.filePath;
        console.log("filePath:", filePath?.[0]?.ChapterTitle);

        const items = datares.choices[0]?.items || [];
        doPagination(filePath, items);

    } catch (error) {
        console.log("Error:", error);
    } finally {
        // Clear searchText after the response is processed
        document.getElementById("searchFrmText").value = "";
        document.getElementById("searchResultText").value = "";

        // Remove spinner regardless of success or failure
        document.getElementById("sp-loading-spinner").classList.remove("active");
    }
}

// async function fetchBookData(searchText) {
//   console.log("searchText", searchText)
//   // const excludeSpinnerQuestions = [
//   //   "What Is Microdosing On Love?",
//   //   "What Is Blockchain?",
//   //   "What Is Valuable Intelligence?",
//   // ];

//   // // Manage spinner visibility
//   // if (excludeSpinnerQuestions.includes(searchText)) {
//   //   document.getElementById("sp-loading-spinner").classList.remove("active");
//   // } else {
//   //   document.getElementById("sp-loading-spinner").classList.add("active");
//   // }

//   // Default value for searchText


// //   const urlParams = new URLSearchParams(window.location.search);
// //   // Extract the `bookNameValue` parameter
// // const bookNameValue = urlParams.get('bookNameValue');

// //   console.log(bookNameValue, urlParams)
  
//   searchText =
//     typeof searchText !== "undefined" && searchText.trim() !== ""
//       ? searchText
//       : "What is machine learning?";

//   const raw1 = JSON.stringify({
//     messages: [
//       {
//         role: "user",
//         content: searchText,
//       },
//     ],
//     temperature: 0.7,
//     top_p: 0.95,
//     frequency_penalty: 0,
//     presence_penalty: 0,
//     max_tokens: 800,
//     stop: null,
//     stream: false,
//   });

//   const requestOptions1 = {
//     method: "POST",
//     headers: myHeaders,
//     body: raw1,
//     redirect: "follow",
//   };

//   const raw2 = JSON.stringify({
//       bookName: bookName ? bookName : "default" , 
//       messages: [
//         {
//           role: "user",
//           content: searchText,
//         },
//       ],
//       temperature: 0.7,
//       top_p: 0.95,
//       frequency_penalty: 0,
//       presence_penalty: 0,
//       max_tokens: 800,
//       stop: null,
//       stream: false,
//     });

//     const requestOptions2 = {
//       method: "POST",
//       headers: myHeaders2,
//       body: raw2,
//       redirect: "follow",
//     };    

//   try {

//     // Second API call
//     const response2 = fetch(
//       "https://newintellectual.com/a/customService",
//       requestOptions2
//     );
//     // First API call
//     const response1 = await fetch(
//       "https://newintellectual.com/a/customService",
//       requestOptions1
//     );
//     const statusCode = response1.status;
//     const resultFirst = await response1.json();
//     // Process the result from the first API
//     console.log("resultFirst", resultFirst)
//     displayApiContent(searchText, resultFirst,statusCode);

//     const resultAPIdata = resultFirst.choices[0]?.message?.newContent || "";
//     const bookQuestions = resultFirst.choices[0]?.questions || [];

//     // Update follow-up questions
//     const ul = document.getElementById("followup-question");
//     const seeLessMoreBtnTxt = document.getElementById("seeLessMoreBtnTxt");
//     ul.innerHTML = "";
//     if (resultAPIdata && bookQuestions.length > 0) {
//       bookQuestions.forEach((question) => {
//         const li = document.createElement("li");
//         li.textContent = question;
//         ul.appendChild(li);

//         li.addEventListener("click", () => {
//           bookName = getBookNameFromUrl(url);
//           console.log("Li clicked",getBookNameFromUrl(url));
//           document.getElementById("searchFrmText").value = li.textContent;
//           document.getElementById("searchbtn").click();
//           window.scrollTo(0, 0);
//           setTimeout(() => {
//             seeLessMoreBtnTxt.textContent = "See More";
//           }, 3000);
//         });
//       });
//     }

//     // Prepare for second API call
//     // const seachText =
//     //   typeof searchText !== "undefined" && searchText.trim() !== ""
//     //     ? searchText
//     //     : "What is machine learning?";

//    const datares = await response2
//   .then(async (data) => {
//     console.log("data"+ data)
//     if (data.ok) { // Check if `ok` is true
//       return await data.json(); // Parse and return the JSON response
//       document.getElementById("searchFrmText").value = "";
//       document.getElementById("searchResultText").value = "";
//     } else {
//       console.log("error")
//       throw new Error("Response was not OK");
//     }
//   })
//   .catch((error) => {
//     console.error("Error:", error.message || error); // Handle any errors
//     return null; // Return null or handle the error case appropriately
//   });

    

//     // Process the result from the second API
//     const filePath = datares.choices[0]?.filePath;
//     const bookData = filePath[0]?.ChapterTitle;
//     console.log("filePath:", filePath[0]?.ChapterTitle); 
//     const items = datares.choices[0]?.items || []; // Define or fetch 'items'
//     doPagination(filePath, items);
    
//   } catch (error) {
//     console.log("Error:", error);
//   } finally {
//     // Remove spinner regardless of success or failure
//     document.getElementById("sp-loading-spinner").classList.remove("active");
//   }
// }


function referenceContent(seachText) {
  seachText =
    typeof seachText != "undefined" && seachText != ""
      ? seachText
      : "what is machine learning?";
  var raw = JSON.stringify({
    messages: [
      {
        role: "user",
        content: seachText,
      },
    ],
    temperature: 0.7,
    top_p: 0.95,
    frequency_penalty: 0,
    presence_penalty: 0,
    max_tokens: 800,
    stop: null,
    stream: false,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders2,
    body: raw,
    redirect: "follow",
  };

  fetch("https://newintellectual.com/a/customService", requestOptions)
    .then((response) => response.json())
    .then((result) => {
      console.log(result, "result")
      const filePath = result.choices[0].filePath;
      doPagination(filePath, items);
    })
    .catch((error) => console.log("error", error));
}

/* pagination */
function clearChat() {
  const tryAgainButton = document.getElementById("tryAgainButton");
  const seeLessMoreBtnTxt = document.getElementById("seeLessMoreBtnTxt");
  if (tryAgainButton) {
    tryAgainButton.style.display = "none"; // Hide the button
  }
  // document.getElementById("tryAgainButton").style.display = "none";
  document.getElementById("searchFrmText").value = "";
  document.getElementById("searchResultText").value = "";
  document.getElementById("resultLists").style.display = "block";
  document.getElementById("paginationBox").style.display = "flex";
  document.getElementById("searchResult").style.display = "none";
  document.getElementById("searchFrm").style.display = "block";
  document.getElementById("search-result-refresh").style.display = "flex";
  document.getElementById("seeLessMoreBtn").style.display = "inline-flex";
  document.getElementById("clear-chat").style.display = "inline-flex";
  seeLessMoreBtnTxt.textContent = "See More";
}

// function clearChat() {
//   // Check if "tryAgainButton" exists in the DOM
//   const tryAgainButton = document.getElementById("tryAgainButton");
//   if (tryAgainButton) {
//     tryAgainButton.style.display = "none"; // Hide the button
//   }

//   // Reset the input fields
//   document.getElementById("searchFrmText").value = "";
//   document.getElementById("searchResultText").value = "";

//   // Update the display properties for other elements
//   document.getElementById("resultLists").style.display = "block";
//   document.getElementById("book0").style.display = "block";
//   document.getElementById("paginationBox").style.display = "flex";
//   document.getElementById("searchResult").style.display = "none";
//   document.getElementById("searchFrm").style.display = "block";
//   document.getElementById("search-result-refresh").style.display = "flex";
//   document.getElementById("seeLessMoreBtn").style.display = "inline-flex";
// }

/*view more & less*/

var fullAnswerTxt = "";
var displayChar = 340;
const artDesc = document.getElementById("resultDescription");

function toggleText(btn) {
  const resultDescription = document.getElementById("resultDescription");
  const seeLessMoreBtnTxt = document.getElementById("seeLessMoreBtnTxt");

  if (btn.getAttribute("data-expanded") === "true" && seeLessMoreBtnTxt.textContent === "See Less" ) {
    // Show Less
    const fullText = resultDescription.getAttribute("data-full-text");
    const truncatedText = fullText.substring(0, 340);

    resultDescription.innerHTML =
      truncatedText + "..."+ '<span class="more-text"></span>';
    seeLessMoreBtnTxt.textContent = "See More";
    btn.setAttribute("data-expanded", "false");
  } else {
    // Show More
    const fullText = resultDescription.getAttribute("data-full-text");

    resultDescription.innerHTML = fullText;
    seeLessMoreBtnTxt.textContent = "See Less";
    btn.setAttribute("data-expanded", "true");
  }
}

//   const btnText = button.querySelector("#seeLessMoreBtnTxt");

//   if (btnText.textContent === "See More") {
//     contentContainer.style.maxHeight = "none"; // Expand content
//     btnText.textContent = "See Less";
//   } else {
//     contentContainer.style.maxHeight = "120px"; // Collapse content
//     btnText.textContent = "See More";
//   }
// }

// function displayApiContent(seachText, customResult) {
//   var parentElement = document.getElementById("searchResult");
//   parentElement.querySelector("h1#searchText").innerText = seachText;
//   document.getElementById("searchResultText").value = seachText;

//   fullAnswerTxt = customResult.choices[0].message.newContent || "";
//   // console.log(fullAnswerTxt);
//   if (
//     typeof fullAnswerTxt != "undefined" &&
//     fullAnswerTxt.length > displayChar
//   ) {
//     parentElement.querySelector(
//       "p#resultDescription"
//     ).textContent = `${fullAnswerTxt}`;
//     document.getElementById("seeLessMoreBtn").style.display = "inline-flex";
//     // document.getElementById("resultLists").style.display = "block";
//     // document.getElementById("paginationBox").style.display = "flex";
//     document.getElementById("search-result-refresh").style.display = "flex";
//   } else if (
//     (fullAnswerTxt =
//       "It seems we couldn't process your query this time, but this might just be a hiccup. Sometimes, retrying the same prompt works because the issue is temporary. Please click 'Try Again' to resubmit your query")
//   ) {
//     // console.log(fullAnswerTxt);
//     document.getElementById("resultDescription").innerHTML = fullAnswerTxt;
//     // document.getElementById("resultLists").style.display = "block";
//     // document.getElementById("paginationBox").style.display = "block";
//     document.getElementById("seeLessMoreBtn").style.display = "none";
//     document.getElementById("search-result-refresh").style.display = "flex";
//   } else {
//     parentElement.querySelector("p#resultDescription").textContent =
//       fullAnswerTxt;
//     document.getElementById("seeLessMoreBtn").style.display = "none";
//   }

//   document.getElementById("searchResult").style.display = "block";
//   document.getElementById("searchFrm").style.display = "none";
// }


function displayApiContent(searchText, customResult,statusCode) {
    console.log("customResult.choices[0].message.newContent", customResult.details)
    console.log("customResult.choices[0].message.newContent", customResult)
  
  
  
  var parentElement = document.getElementById("searchResult");
  parentElement.querySelector("h1#searchText").innerText = searchText;
  document.getElementById("searchFrmText").value = searchText;
  const searchResultButton = document.getElementById("search-result-refresh");
  const buttonText = searchResultButton.querySelector("span");
  let fullAnswerTxt = "";
  if (statusCode === 429) {
    // Handling rate limit exceeded error
    parentElement.querySelector(
      "h1#searchText"
    ).textContent = `Oops, Something went Wrong!`;
    fullAnswerTxt =
      "The rate limit for AI request has been exceeded. Please try again after 5 minutes.";
    parentElement.querySelector("p#resultDescription").textContent =
      fullAnswerTxt;
    document.getElementById("seeLessMoreBtn").style.display = "none";
    document.getElementById("search-result-refresh").style.display = "inline-flex";
        const tryAgainButton = document.getElementById("tryAgainButton");
    if (tryAgainButton) {
      tryAgainButton.style.display = "none"; // Hide the button
    }
    if (!parentElement.querySelector("button#tryAgainButton")) {
    // Create "Try Again" button
    const tryAgainButton = document.createElement("button");
    tryAgainButton.id = "tryAgainButton"; // Assign an ID to the button
    tryAgainButton.textContent = "Try Again";
    tryAgainButton.id = "tryAgainButton";
    // Add the specified styles to the button
    tryAgainButton.style.fontSize = "16px";
    tryAgainButton.style.padding = "13px 25px";
    tryAgainButton.style.lineHeight = "1";
    tryAgainButton.style.color = "#5e5b5e";
    tryAgainButton.style.textDecoration = "unset";
    tryAgainButton.style.border = "1px solid rgba(0, 0, 0, 0.2)";
    tryAgainButton.style.display = "inline-flex";
    tryAgainButton.style.alignItems = "center";
    tryAgainButton.style.borderRadius = "5px";
    tryAgainButton.style.boxShadow = "0 0 4px #0000001a";
    tryAgainButton.style.cursor = "pointer";
    tryAgainButton.style.backgroundColor = "#FFF"; // Optional for better contrast

    // Add click event to the button
    tryAgainButton.addEventListener("click", () => {
      location.reload(); // Reload the page or handle the logic to retry
      hideTryAgainButton()
    });

    // Append the button after resultDescription
    resultDescription.parentElement.appendChild(tryAgainButton);
    }
    document.getElementById("tryAgainButton").style.display = "flex";
    document.getElementById("resultDescription").style.display = "flex";
    document.getElementById("seeLessMoreBtnTxt").style.display = "flex";
    document.getElementById("seeLessMoreBtn").style.display = "flex";
    document.getElementById("followup-question").style.display = "none";
    document.getElementById("resultLists").style.display = "none";
    document.getElementById("referContentValue").style.display = "none";
    document.getElementById("clear-chat").style.display = "none";
    // document.getElementById("tryAgainButton").style.display = "flex";
    document.getElementById("seeLessMoreBtn").style.display = "none";
  } 
  else if (customResult.choices && customResult.choices[0].message && statusCode === 200) {
    fullAnswerTxt = 
  typeof customResult.choices[0].message.newContent === "string"
    ? customResult.choices[0].message.newContent
    : "";

    if (fullAnswerTxt.length > 0) {
      parentElement.querySelector(
        "p#resultDescription"
      ).textContent = `${fullAnswerTxt}`;
      // const truncatedText = fullAnswerTxt.substring(0, 340);
      // const moreText = fullAnswerTxt.substring(100);

      // const resultDescriptions = document.getElementById("resultDescription");
      // resultDescriptions.setAttribute("data-full-text", fullAnswerTxt);
      // if (fullAnswerTxt) {
      //   resultDescriptions.innerHTML =
      //     truncatedText+ "..." + '<span class="more-text"></span>';
      // }
      const truncatedText = fullAnswerTxt.substring(0, 340);
      const moreText = fullAnswerTxt.substring(340); // Ensure this starts after 340 characters
      const tryAgainButton = document.getElementById("tryAgainButton");
      const resultDescriptions = document.getElementById("resultDescription");
      resultDescriptions.setAttribute("data-full-text", fullAnswerTxt);
      const seeLessMoreBtnTxt = document.getElementById("seeLessMoreBtnTxt");
      const seeLessMoreBtn = document.getElementById("seeLessMoreBtn");
      if (fullAnswerTxt) {
        if (fullAnswerTxt.length > 340) {
          // Show truncated text with "more-text"
          resultDescriptions.innerHTML =
            truncatedText + "..." + '<span class="more-text"></span>';
            // tryAgainButton.style.display = "none";
        } else {
          // Display full text and hide "more-text"
          resultDescriptions.innerHTML = truncatedText;
          seeLessMoreBtn.style.display = "none";
        }
      }

      
      if (tryAgainButton) {
        tryAgainButton.style.display = "none"; // Hide the button
      }
      document.getElementById("search-result-refresh").style.display = "none";
      document.getElementById("followup-question").style.display = "block";
      document.getElementById("resultLists").style.display = "block";
     
      if (seeLessMoreBtn) {
        // Check the current state and update accordingly
        if (seeLessMoreBtnTxt.textContent === "See More") {
          seeLessMoreBtnTxt.textContent === "See Less"
          seeLessMoreBtn.style.display = "inline-flex";
        } else {
          // Optional: Additional logic for "See Less" state
          seeLessMoreBtnTxt.textContent === "See More"
          // seeLessMoreBtn.style.display = "none"; // Or leave inline-flex if required
        }
      }

      // document.getElementById("seeLessMoreBtn").style.display = "inline-flex";
      document.getElementById("clear-chat").style.display = "inline-flex";
      buttonText.textContent = "Try Again";
      
    } 
    else {
      parentElement.querySelector(
        "h1#searchText"
      ).textContent = `Oops, Something went Wrong!`;
      fullAnswerTxt = `The document does not have an answer to that question. please submit an diffrent prompt, and "Try Again".`;
      parentElement.querySelector(
        "p#resultDescription"
      ).textContent = `${fullAnswerTxt}`;
  if (!parentElement.querySelector("button#tryAgainButton")) {
    // Create "Try Again" button
    const tryAgainButton = document.createElement("button");
    tryAgainButton.id = "tryAgainButton"; // Assign an ID to the button
    tryAgainButton.textContent = "Try Again";
    tryAgainButton.id = "tryAgainButton";
    // Add the specified styles to the button
    tryAgainButton.style.fontSize = "16px";
    tryAgainButton.style.padding = "13px 25px";
    tryAgainButton.style.lineHeight = "1";
    tryAgainButton.style.color = "#5e5b5e";
    tryAgainButton.style.textDecoration = "unset";
    tryAgainButton.style.border = "1px solid rgba(0, 0, 0, 0.2)";
    tryAgainButton.style.display = "inline-flex";
    tryAgainButton.style.alignItems = "center";
    tryAgainButton.style.borderRadius = "5px";
    tryAgainButton.style.boxShadow = "0 0 4px #0000001a";
    tryAgainButton.style.cursor = "pointer";
    tryAgainButton.style.backgroundColor = "#FFF"; // Optional for better contrast

    // Add click event to the button
    tryAgainButton.addEventListener("click", () => {
      location.reload(); // Reload the page or handle the logic to retry
      hideTryAgainButton()
    });

    // Append the button after resultDescription
    resultDescription.parentElement.appendChild(tryAgainButton);
    }
      buttonText.textContent = "Search Results";
      document.getElementById("tryAgainButton").style.display = "flex";
      document.getElementById("resultDescription").style.display = "flex";
      document.getElementById("seeLessMoreBtn").style.display = "none";
      document.getElementById("followup-question").style.display = "none";
      document.getElementById("resultLists").style.display = "none";
      document.getElementById("resultLists").style.display = "none";
      document.getElementById("referContentValue").style.display = "none";
      document.getElementById("search-result-refresh").style.display = "flex";
      document.getElementById("clear-chat").style.display = "none";

    }
  } else {
    parentElement.querySelector(
      "h1#searchText"
    ).textContent = `Oops, Something went Wrong!`;
    parentElement.querySelector("p#resultDescription").textContent =
      "An unexpected error occurred. Please try again.";
    const tryAgainButton = document.createElement("button");
    tryAgainButton.textContent = "Try Again";
    document.getElementById("seeLessMoreBtn").style.display = "none";
  }

  document.getElementById("searchResult").style.display = "block";
  document.getElementById("searchFrm").style.display = "none";
}

// Function to hide the "Try Again" button during navigation
function hideTryAgainButton() {
  const tryAgainButton = document.getElementById("tryAgainButton");
  if (tryAgainButton) {
    tryAgainButton.style.display = "none";
  }
}
document.querySelectorAll("#clearChat").forEach((div) => {
  div.addEventListener("click", () => {
    hideTryAgainButton();
  });
});

function doPagination(item, filePath) {
  bookdata = item;
  let currentPage = 1;
  var totalItems = item.length;
  var totalPages = Math.ceil(totalItems / itemsPerPage);
  displayItems(currentPage, item, filePath);
  createPaginationButtons(currentPage, totalPages);
}

function displayItems(pageNumber, items, filePath) {
  // console.log(items.length);
  console.log(typeof filePath.length, filePath.length == 0);

  const itemList = document.getElementById("resultLists");
  const referContentValue = document.getElementById("referContentValue");
  const resultDescription = document.getElementById("resultDescription");
  const errorResponse = {
    statusCode: 429,
    message: "Rate limit is exceeded. Try again in 54 seconds.",
  };

  var startValue = pageNumber * 3 - 2;

  const startIndex = (pageNumber - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  // console.log(endIndex, startIndex);

  itemList.innerHTML = "";
  let innerHtmlContent = "";
  if (items.length > 0) {
    // if(filePath.length == 0 ){
    // referContentValue.style.display = "none";
    // }else{
    //   referContentValue.style.display = "block";
    // }
    for (let i = startIndex; i < endIndex && i < items.length; i++) {
      var itemTermsVal = "";
      const incrementedValue = startValue + i;

      // for (let k = 0; k < items[i].Terms.length; k++) {
      //   itemTermsVal += `<div class="tag-wrap popup-${k + 1}" id="popup-${
      //     k + 1
      //   }">${items[i].Terms[k]}</div>`;
      // }
      for (let k = 0; k < items[i].Terms.length; k++) {
      // Replace curly quotes, invalid characters, or others with the same or corrected equivalents
      const sanitizedTerm = items[i].Terms[k].split(':')[0]
        .replace(/’|‘/g, "'") // Replace curly quotes with standard single quote
        .replace(/�/g, "'"); // Replace invalid character � with standard single quote
    
      itemTermsVal += `<div class="tag-wrap popup-${k + 1}" id="popup-${
        k + 1
          }">${sanitizedTerm}</div>`;
        }

      innerHtmlContent += `<div class="list-block" id="book${i}">
            <div class="img">
              <a href="${items[i].Thumbnail}" target="_blank"><img src="${items[i].Thumbnail}" alt="Thumbnail"/></a>
            </div>
            
            <div class="list-content">
              <h6><a href="${items[i].URL}" target="_blank">${incrementedValue}. ${items[i].ChapterTitle}</a></h6>
              <div class="bookTitle"><a href="${items[i].URL}" target="_blank">${items[i].BookTitle}</a></div>
              <div class="bookTitleDetials"> <strong>Author : ${items[i].Author}</strong></div>
              <div class="summary-content summary-count-0 data-id=0">
                <div class="summary-paragraph summary-para-0">
                  <p>
                    ${items[i].Summary}<a href="${items[i].URL}" target="_blank"></a>
                  </p>
                </div>
              </div>
              <a href="javascript:void(0);" class="show-more-summary">Show More </a>
              <div class="com-tag-wrap">
                ${itemTermsVal}
              </div>
            </div>
          </div>`;
    }
  } else {
    referContentValue.style.display = "none";
    resultDescription.style.display = "flex";
  }

  itemList.innerHTML = innerHtmlContent;

  // com-tag-wrap

  $(".com-tag-wrap").each(function () {
    var LiN = $(this).find(".tag-wrap").length;
    console.log(LiN);
    if (LiN > 3) {
      $(".tag-wrap", this).eq(2).nextAll().hide().addClass("toggleable");
      $(this).append('<a class="more">Read More</a>');
    }
  });
  $(".com-tag-wrap").on("click", ".more", function () {
    if ($(this).hasClass("less")) {
      $(this).text("Read More").removeClass("less");
    } else {
      $(this).text("Read Less").addClass("less");
    }
    $(this).siblings(".tag-wrap.toggleable").slideToggle(0);
  });

  var tagWraps = document.querySelectorAll(".tag-wrap");
  console.log("items[i].BookTitle", items[0].BookTitle)
  const bookTitle = items[0].BookTitle
  tagWraps.forEach(function (tagWrap) {
    tagWrap.addEventListener("click", function () {
      var glossrayWord = tagWrap.textContent;
      // console.log(glossrayWord);
      openPopup(glossrayWord, bookTitle);
    });
  });

  // Function to open popup on working code
  function openPopup(glossrayWord, bookTitle) {
    console.log("bookTitle", bookTitle)
    const myHeaders = new Headers();
    myHeaders.append("fetch", "aiDocs");
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
    "term" : glossrayWord,
    "title": bookName ? bookName : bookTitle
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch("https://newintellectual.com/a/customService", requestOptions)
      .then((response) => response.json())
      .then((text) => {
      console.log(text, text.length , typeof text.length)
        var mainContainer = document.getElementById("modal-second");

        let matchingResultFound = false;
        var glossaryModal = "";

        if (text.length > 0) {
          glossaryModal +=
            '<div><div class="modal-box"><div class="absolute-popup"><div class="article_content_new">';
          for (let index = 0; index < text.length; index++) {
            var termValue = text[index].Term;
            console.log(termValue);
                    console.log(termValue);

                    // ✅ Replace all single quotes with � for proper matching
                    if (termValue.includes("'")) {
                        termValue = termValue.replace(/'/g, "�");
                    }
            if (termValue.includes(glossrayWord) || glossrayWord.replace(/'/g, "�") === termValue) {
              console.log("termValue.includes(glossrayWord)",termValue, termValue.includes(glossrayWord))
              
              matchingResultFound = true;
              glossaryModal +=
                '<div class="article_header"><div class="article_heading text-center"><p>' +
                glossrayWord +
                '</p></div><a class="redbtn" href="javascript:void(0)" close-modal><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.859 1.50684L1.66992 16.6959" stroke="black" stroke-width="1.5189" stroke-linecap="round" stroke-linejoin="round"></path><path d="M1.66992 1.50684L16.859 16.6959" stroke="black" stroke-width="1.5189" stroke-linecap="round" stroke-linejoin="round"></path></svg></a></div>';
              glossaryModal +=
                '<div class="article_body"><p>' +
                text[index].Content +
                "</p></div>";

              glossaryModal +=
                '<div class="articleDeatils"><div class="articleImg"><img src=' +
                text[index].Thumbnail +
                ' alt=""></div>';
              glossaryModal += '<div class="articleText">';
              glossaryModal +=
                '<h2 class="heading"><a href="' +
                text[index].URL +
                '">' +
                text[index].ChapterTitle +
                "</a></h2>";
              glossaryModal +=
                '<h2 class="subheading"><a href="' +
                text[index].URL +
                '">' +
                text[index].BookTitle +
                "</a></h2>";
              glossaryModal +=
                '<span class="lightGray">Author :' +
                text[index].Author +
                "</a></span></div></div>";

              document.querySelector(".modal").classList.add("active");
            }
          }
        }
        if (!matchingResultFound) {
          glossaryModal +=
            "<div class=article_body><li> No results match the search </li></div>";
          document.querySelector(".modal").classList.add("active");
        }
        glossaryModal +=
          '<div class="closeBtn"><a class="redbtn" href="javascript:void(0);" close-modal> <img src="https://cdn.shopify.com/s/files/1/0772/2614/8156/files/Frame_781.svg?v=1707403126"> Close Window</a></div></div></div></div>';
        mainContainer.innerHTML = glossaryModal;

        document.querySelectorAll("[open-modal]").forEach(function (element) {
          element.addEventListener("click", function () {
            var id = element.getAttribute("open-modal");
            document.querySelector(".modal").classList.add("active");
          });
        });

        document.querySelectorAll("[close-modal]").forEach(function (element) {
          element.addEventListener("click", function () {
            element.closest(".modal").classList.remove("active");
          });
        });

        document.querySelectorAll(".modal").forEach(function (modal) {
          modal.addEventListener("click", function (e) {
            if (e.target === this) {
              modal.classList.remove("active");
            }
          });
        });
      })
      .catch((error) => console.error(error));
  }
  // Show more content

  $(function () {
    $(".show-more-summary").click(function (e) {
      if (e.target.innerHTML == "Show More") {
        e.target.innerHTML = "Show Less";
        e.target.previousElementSibling.style.maxHeight = "fit-content";
      } else {
        e.target.innerHTML = "Show More";
        e.target.previousElementSibling.style.maxHeight = "120px";
      }
    });
  });

  // $(function () {
  //   var nav = $(".summary-content"),
  //     animateTime = 500,
  //     navLink = $(".show-more-summary");
  //   navLink.click(function (e) {
  //     if (e.target.innerHTML == "Show More") {
  //       e.target.innerHTML = "Show Less";
  //       e.target.previousElementSibling.style.maxHeight = "fit-content";
  //     } else {
  //       e.target.innerHTML = "Show More";
  //       e.target.previousElementSibling.style.maxHeight = "120px";
  //     }
  //   });
  // });

  // Reference Content
  // $(document).ready(function () {
  //   // Initially hide the element
  //   $(".result-output-sc").hide();
  
  //   // Ensure no duplicate handlers and toggle behavior
  //   $(document)
  //     .off("click", ".click-me")
  //     .on("click", ".click-me", function () {
  //       console.log("Button clicked");
  
  //       // Toggle visibility of the targeted element
  //       $(".result-output-sc").slideToggle();
  //     });
  // });

$(document).ready(function () {
  // Initially hide the element and set button text
  $(".result-output-sc").hide();
  $("#referContentValue").text("References");

  // Ensure no duplicate handlers and toggle behavior
  $(document)
    .off("click", "#referContentValue")
    .on("click", "#referContentValue", function () {
      console.log("Button clicked");

      // Toggle visibility of the targeted element
      $(".result-output-sc").slideToggle("fast", function () {
        // This function runs after the toggle completes
        if ($(".result-output-sc").is(":visible")) {
          $("#referContentValue").text("References");
        }
      });
    });
});

  $(document).ready(function () {
  // Initially show the element and set button text
  $(".result-output-sc").show();  // <-- changed this
  $("#referContentValue").text("Hide References"); // Optional: show 'Hide References' by default

  // Ensure no duplicate handlers and toggle behavior
  $(document)
    .off("click", "#referContentValue")
    .on("click", "#referContentValue", function () {
      console.log("Button clicked");

      $(".result-output-sc").slideToggle("fast", function () {
        if ($(".result-output-sc").is(":visible")) {
          $("#referContentValue").text("Hide References");
        } else {
          $("#referContentValue").text("References");
        }
      });
    });
});




  function autoHeightAnimate(element, time) {
    var curHeight = element.css("height", "120").height(), // Get Default Height
      autoHeight = element.css("height", "auto").height(); // Get Auto Height
    element.height(curHeight); // Reset to Default Height
    element.stop().animate({ height: autoHeight }, time); // Animate to Auto Height
  }

  // end search input box
}

function prevButtonHtml(currentPage, totalPages) {
  if (currentPage > 1) {
    return `<li class="next np-icon">
          <a href="javascript:void(0)" class="next" aria-label="Next" title="Next »" onclick="changePage(${--currentPage}, ${totalPages})">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z"></path>
            </svg>
          </a>
        </li>`;
  } else {
    return `<li class="next np-icon">
          <a href="javascript:void(0)" class="next disabled-btn" aria-label="Next" title="Next »" disabled>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z"></path>
            </svg>
          </a>
        </li>`;
  }
}

function firstButtonHtml(currentPage, totalPages) {
  if (currentPage == 1) {
    return `<li class="number active"><a href="javascript:void(0)">1</a> </li>`;
  } else {
    return `<li class="number"><a href="javascript:void(0)" onclick="changePage(1, ${totalPages})">1</a></li>`;
  }
}

function dotButtonHtml() {
  return `<li class="number"><a href="javascript:void(0)">…</a></li>`;
}

function paginationButtonHtml(pageNumber, currentPage, totalPages) {
  if (pageNumber == currentPage) {
    return `<li class="number active"><a href="javascript:void(0)" title="${pageNumber}">${pageNumber}</a></li>`;
  } else {
    return `<li class="number"><a href="javascript:void(0)" title="${pageNumber}" onclick="changePage(${pageNumber}, ${totalPages})">${pageNumber}</a></li>`;
  }
}

function lastButtonHtml(currentPage, totalPages) {
  if (currentPage == totalPages) {
    return `<li class="number active"><a href="javascript:void(0)">${totalPages}</a> </li>`;
  } else {
    return `<li class="number"><a href="javascript:void(0)" onclick="changePage(${currentPage}, ${totalPages})">${totalPage}</a></li>`;
  }
}

function nextButtonHtml(currentPage, totalPages) {
  if (currentPage < totalPages) {
    return `<li class="next np-icon">
          <a href="javascript:void(0)" class="next" aria-label="Next" title="Next »" onClick="changePage(${++currentPage}, ${totalPages})">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M13.1714 12.0007L8.22168 7.05093L9.63589 5.63672L15.9999 12.0007L9.63589 18.3646L8.22168 16.9504L13.1714 12.0007Z"></path>
            </svg>
          </a>
        </li>`;
  } else {
    return `<li class="next np-icon">
          <a href="javascript:void(0)" class="next disabled-btn" aria-label="Next" title="Next »" disabled>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M13.1714 12.0007L8.22168 7.05093L9.63589 5.63672L15.9999 12.0007L9.63589 18.3646L8.22168 16.9504L13.1714 12.0007Z"></path>
            </svg>
          </a>
        </li>`;
  }
}

function createPaginationButtons(currentPage, totalPages) {
  const pagination = document.getElementById("paginationBox");
  if (parseInt(totalPages) > 1) {
    let paginationHtml = "";

    paginationHtml += prevButtonHtml(currentPage, totalPages);

    if (currentPage > 3) {
      paginationHtml += firstButtonHtml(currentPage, totalPages);
      if (currentPage > 4) {
        paginationHtml += dotButtonHtml();
      }
    }

    for (
      let i = Math.max(1, currentPage - 2);
      i <= Math.min(totalPages, currentPage + 2);
      i++
    ) {
      paginationHtml += paginationButtonHtml(i, currentPage, totalPages);
    }

    if (currentPage < totalPages - 2) {
      if (currentPage < totalPages - 3) {
        paginationHtml += dotButtonHtml();
      }
      /*when someone click on last page that time the current page will be the last page so 
    we pass here totalpage as current page*/
      paginationHtml += lastButtonHtml(totalPages, totalPages);
    }

    paginationHtml += nextButtonHtml(currentPage, totalPages);

    pagination.innerHTML = paginationHtml;
  } else {
    pagination.innerHTML = "";
  }
}

/* End of pagination */

function changePage(currentPage, totalPages) {
  console.log(bookdata, "bookdata****");
  displayItems(currentPage, bookdata);
  createPaginationButtons(currentPage, totalPages);

  $(".number, .next, .number.active ").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });
}
